export var canUseDOM = function canUseDOM() {
  return !(typeof window === "undefined" || window.document === undefined || window.document.createElement === undefined);
};
export var combineRefs = function combineRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (instance) {
    for (var _i = 0, _refs = refs; _i < _refs.length; _i++) {
      var item = _refs[_i];

      if (item === null || item === undefined) {
        continue;
      }

      if (typeof item === "object") {
        item.current = instance;
      } else {
        item(instance);
      }
    }
  };
};
export var noop = function noop() {};